// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"962e5c6b","455":"f03849ad","977":"2b22203a"}[chunkId] + ".chunk.js";
};